import { IQuizzesResponse, IQuiz } from './types'

import { client } from 'src/utils/client'
import config from 'src/config'

export const getQuizzes = async (
  quizStatus: 'new' | 'completed'
): Promise<IQuizzesResponse> =>
  await client(`${config.HOST_API}/quizzes?status=${quizStatus}`)

export const getQuiz = async (id: string): Promise<IQuiz> =>
  await client(`${config.HOST_API}/quizzes/${id}`)

export const getInitialQuiz = async (): Promise<IQuiz> =>
  await client(`${config.HOST_API}/quizzes/initial`)
